<main class="p-6 pb-10 ml-[52px] h-[calc(100vh_-_70px)] overflow-hidden">
    <div class="mb-6 flex justify-between items-center">
        <h1 class="text-shs-white-1 font-bold flex items-center gap-1 font-sh-bree" style="font-size: 30px">
            <span
                (click)="cancelCreation()"
                class="icon-chevron-left text-shs-orange text-3xl cursor-pointer"
                style="font-size: 30px"
            ></span
            >Create new COD
        </h1>
        <sag-ui-button icon="close" size="sm" color="tertiary" (click)="cancelCreation()">Cancel</sag-ui-button>
    </div>
    <div class="flex items-start gap-8 h-full w-full">
        <app-stepper></app-stepper>
        @if (formGroup) {
        <div
            class="flex flex-col gap-8 pb-24 overflow-y-auto h-full w-full relative"
            [formGroup]="formGroup"
            ngxsForm="cod.form"
            #stepsContainer
        >
            @if (errorMessages(); as messages) { @if (messages.length > 0) {
            <div class="sticky top-0 left-0 right-0 w-full bg-background p-2 z-[500]">
                <div class="rounded-md bg-shs-red grid grid-cols-[50px_auto_50px] shadow-md items-center p-4">
                    <span class="icon-circle-error text-white text-3xl"></span>
                    <span class="text-white text-sm font-bold pr-8">{{ messages[0] }}</span>
                    <span class="icon-close text-white text-xl cursor-pointer" (click)="popErrorMessage()"></span>
                </div>
            </div>
            } } @switch (viewMode()) { @case (viewModes.FORM) { @for (cod of codLines(); track $index) {
            <app-cod-detail-card [data]="cod" [expandable]="true" [open]="false"></app-cod-detail-card>
            }
            <app-cod-create-form
                [formGroup]="formGroup"
                [steps]="steps()"
                [disableValidation]="disableValidation()"
            ></app-cod-create-form>
            } @case (viewModes.SUMMARY) {
            <app-cod-summary-step [copyId]="copyId"></app-cod-summary-step>
            } @case (viewModes.SUBMITTING) {
            <app-cod-submitting-step></app-cod-submitting-step>
            } }
        </div>
        }
    </div>
</main>
